import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import styled from "styled-components";

const StyledBox = styled(Box)(({ theme }) => ({}));

const BasePageLayout = () => {
  return (
    <StyledBox sx={{ border: "0px solid red" }}>
      <Outlet />
    </StyledBox>
  );
};

export default BasePageLayout;
